import React from 'react';
import { Field, Form } from 'react-final-form';
import FieldTextInput from 'Components/FormFields/FieldTextInput';
import { OnSubmitReturnType } from 'Interfaces/FinalForm';
import { composeValidators } from 'Utils/functions';
import { maxLength100, notOnlySpaces, required } from 'Utils/validation';

interface RenameTitleFormProps {
  templateTitle: string;
  onSubmit: ({ title: string }) => OnSubmitReturnType;
}
const EditableTitle = ({ templateTitle, onSubmit }: RenameTitleFormProps) => {
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{ title: templateTitle }}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <Field
            name="title"
            component={FieldTextInput}
            autofocus
            hidden
            validate={composeValidators<string>(required, notOnlySpaces, maxLength100)}
          />
        </form>
      )}
    />
  );
};
export default EditableTitle;
